import { useState } from 'react'

interface ComposioAppIconProps {
  logo: string | null
  name: string
  className?: string
}

export default function ComposioAppIcon({ logo, name, className = 'h-10 w-10' }: ComposioAppIconProps) {
  const [imgError, setImgError] = useState(false)

  if (logo && !imgError) {
    return (
      <div className={`${className} rounded flex items-center justify-center ${name === 'GitHub' ? 'dark:bg-white dark:rounded-lg' : ''}`}>
        <img
          src={logo}
          alt={name}
          className="h-full w-full rounded object-contain"
          loading="lazy"
          onError={() => setImgError(true)}
        />
      </div>
    )
  }

  return (
    <div className={`${className} rounded-xl bg-primary/10 flex items-center justify-center text-sm font-semibold text-primary`}>
      {name.charAt(0).toUpperCase()}
    </div>
  )
}
